export const ARTISTS = [
  {
    id: "biia",
    name: "BIIA",
    origin: "Portugal",
    tag: "Hard Techno",
    bio: "Portugal's fastest-rising hard-techno force. Raw '90s kicks, ghost-whisper vocal hooks and sets built like horror films you can dance to. Awakenings, Tomorrowland, Boiler Room and EDC have all fallen for it — now it's India's turn.",
    image: "/images/artists/biia.jpg",
    credit: "Photo: @hugoladetente",
  },
  {
    id: "tigerhead",
    name: "TIGERHEAD",
    origin: "Berlin",
    tag: "Hypnotic Techno",
    bio: "Czech-born, Berlin-forged. Her HÖR broadcast sits at the top of the platform's most-watched sets ever — 2M+ views of pure, unpredictable chaos. Berghain regular, Boiler Room alumna, co-founder of THC Agency.",
    image: "/images/artists/tigerhead.jpg",
    credit: "Photo: Resident Advisor",
  },
  {
    id: "domina",
    name: "DØMINA",
    origin: "Los Angeles",
    tag: "Industrial / Hardstyle",
    bio: "Classically trained on piano at five, chaos-trained on the decks ever since. DØMINA's metallic, full-throttle industrial hard techno has detonated main stages at EDC Las Vegas, Accor Arena Paris and Lost Lands.",
    image: "/images/artists/domina.jpg",
    credit: "Photo: Active Talent Agency",
  },
];

export const EVENTS = {
  delhi: {
    city: "Delhi",
    citySlug: "delhi",
    eyebrow: "HÖR On Tour",
    title: "HALLOWEEN EDITION",
    tagline: "Berlin Underground. Delhi After Dark.",
    seoTitle: "HÖR on Tour – Halloween Edition, Delhi 2026 | Get Tickets",
    seoDescription:
      "HÖR Berlin's Halloween edition hits Delhi. BIIA, TIGERHEAD & DØMINA live at Bel-La Monde Hotel, NH8 on Fri 30 Oct 2026. Tickets from ₹999.",
    venueName: "Bel-La Monde Hotel, NH8",
    venueAddress: "NH8, Gurgaon–Delhi Expy, Near Shiv Murti, New Delhi",
    dateLabel: "Friday, 30 October 2026",
    timeLabel: "8:00 PM – 10:00 PM",
    dateISO: "2026-10-30T20:00:00+05:30",
    presenter: "Presented by sLick!",
    ticketPartner: "Exclusive ticketing partner — Roaming Events",
    ticketUrl:
      "https://www.roamingevents.com/events/hr-on-tour-halloween-edition-delhi-2026",
    priceLabel: "Starting ₹999",
    mapQuery:
      "NH8, Gurgaon - Delhi Expy, Near Shiv Murti, New Delhi, Delhi 110038",
  },
  bangalore: {
    city: "Bangalore",
    citySlug: "bangalore",
    eyebrow: "HÖR Berlin x sLick!",
    title: "HALLOWEEN EDITION",
    tagline: "Berlin Underground. Bangalore After Dark.",
    seoTitle: "HÖR Berlin x sLick! – Halloween Edition, Bangalore 2026 | Get Tickets",
    seoDescription:
      "HÖR Berlin's Halloween edition hits Bangalore. BIIA, TIGERHEAD & DØMINA live at DND The Venue, HSR Layout on Sat 31 Oct 2026. Tickets from ₹999.",
    venueName: "DND The Venue, HSR Layout",
    venueAddress: "DND The Venue, HSR Layout, Bengaluru",
    dateLabel: "Saturday, 31 October 2026",
    timeLabel: "From 4:00 PM",
    dateISO: "2026-10-31T16:00:00+05:30",
    presenter: "Presented by sLick!",
    ticketPartner: "Tickets on Swiggy Scenes",
    ticketUrl:
      "https://www.swiggy.com/scenes/party-and-nightlife/hor-berlin-x-slick-bengaluru-halloween-2026/bangalore/100127499",
    priceLabel: "Starting ₹999",
    mapQuery: "DND The Venue, HSR Layout, Bangalore",
  },
};
